import { useProjectName } from '~/hooks/api/useProjectName';

const PageTitle = () => {
  const { isFetching: isFetchingproject, data: projectName } = useProjectName();

  return <title>{isFetchingproject ? 'MEP' : (projectName ?? 'MEP')}</title>;
};

export default PageTitle;
